import {CONSTANTS} from '@/constants';
import { functions } from '@/functions';
import miniToastr from 'mini-toastr'

export const functions_botphrase = {

    data: function () {
        return {
            bot_categories:[],
            bot_phrase: null
        };
    },

    computed: {
    },

    methods: {
        loadBotCategories: function (onSuccess=null, param=null) {
            this.bot_categories = [];
            this.httpPrepare();
            this.$http.get(this.apiurl('bot/categories')).then(function (response) {
                response = this.httpSuccess(response);
                this.bot_categories = response.payload;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
            return this;
        },

        getNextBotPhrase: function (onSuccess=null, param=null) {
            this.bot_phrase = null;
            this.httpPrepare();
            this.$http.get(this.apiurl('bot/phrases-next')).then(function (response) {
                response = this.httpSuccess(response);
                this.bot_phrase = response.payload;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
            return this;
        },

        saveBotPhrase: function (categories, onSuccess=null, param=null) {
            let bot_phrase = this.bot_phrase;
            this.bot_phrase = null;
            this.httpPrepare();
            this.$http.put(this.apiurl('bot/phrases-save/'+bot_phrase.id), {categories:categories}).then(function (response) {
                response = this.httpSuccess(response);
                this.bot_phrase = response.payload;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
            return this;
        },

    }
};

